var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border",class:`spinner-border-${_vm.size}`,style:(_vm.style),attrs:{"role":"status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }